import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import { maintenanceService } from 'services/api';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { GridColDef } from '@mui/x-data-grid-premium';
import { MaintenanceColumns } from 'components/common/enhanced/common-headers';
import CloseMaintenanceDialog from './CloseMaintenanceDialog';
import { IMaintenance } from 'interfaces';

export const WaitingMaintenances = () => {
  const translationPrefix = 'pages.maintenance-waiting';

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const [open, setOpen] = useState(false);
  const [maintenanceId, setMaintenanceId] = useState<number | null>(null);
  const [expectedDate, setExpectedDate] = useState<string | null>(null);

  const setOpenDialog = (row: IMaintenance) => {
    setOpen(true);
    setMaintenanceId(row.id);
    setExpectedDate(row.expected_date);
  };

  const setCloseDialog = () => {
    setOpen(false);
    setMaintenanceId(null);
    setExpectedDate(null);
  };

  const columns: GridColDef[] = MaintenanceColumns(setOpenDialog, false, false, true);

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}>
        <EnhancedDataGrid
          columns={columns}
          service={maintenanceService}
          getMethod={maintenanceService.getWaitingMaintenances}
          refresh={datagridRefresh}
        />
        <CloseMaintenanceDialog
          closeDialog={setCloseDialog}
          datagridRefresh={datagridRefresh}
          id={maintenanceId}
          open={open}
        />
      </TenantPage>
    </>
  );
};

export default WaitingMaintenances;
